import { Password } from './../../shared/user.model';
import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { NgForm } from '@angular/forms';
import { Login } from '../../shared/user.model';
import swal from 'sweetalert2';
import { RegistrationService } from '../../registration.service';


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  isSMSResent: any;
  showLodingSpinner: boolean;
  formSubmitted: boolean;
  @Output() change = new EventEmitter();
  isLoginError: boolean = false;
  isServiceNoHavingPhone: boolean =false;

  constructor(private router: Router,private userService: RegistrationService) {
    this.formSubmitted = false;
    this.showLodingSpinner = false;
  }

  ngOnInit() {
    
    document.getElementById('IsServiceHavingPhone').style.display = "none";
    if (localStorage.getItem('accessToken')!=null){
    this.GetAllowedPages()
    }
  }
 debugger;
  Login(form: NgForm) {
     this.userService.isServiceNoHavingPhone(form.value.UserName).subscribe(
      (response:any) => {        
        this.isServiceNoHavingPhone = response;
        //form.value.IsServiceHavingPhone = response;        
        //swal("warning!",this.isServiceNoHavingPhone.toString(), "warning");
        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        document.getElementById('loader-spinner').style.display = "none";
      });   
      if (this.isServiceNoHavingPhone == false)
      {
        //form.get['OTP'].clearvalidators();
        form.controls["OTP"].clearValidators();
        form.controls["OTP"].updateValueAndValidity();
        if (!form.invalid) {
          this.showLodingSpinner = true;    
          this.userService.userAuthentication(form.value)
            .subscribe((data: any) => {
              localStorage.setItem('accessToken', data.access_token);
              localStorage.setItem('userName', data.userName);
              localStorage.setItem('userRole', data.userRole);
              localStorage.removeItem('selectedMenu');          
              this.GetAllowedPages();
            },
              (err: HttpErrorResponse) => {
                this.isLoginError = true;
                this.showLodingSpinner = false;
               // swal('','Username or password is not correct!');
               swal('',err.error.error_description);
              });
        } else
          this.formSubmitted = true;
      }
      else
      {
        if (!form.invalid) {
          this.showLodingSpinner = true;
          this.userService.userAuthentication(form.value)
            .subscribe((data: any) => {
              localStorage.setItem('accessToken', data.access_token);
              localStorage.setItem('userName', data.userName);
              localStorage.setItem('userRole', data.userRole);
              localStorage.removeItem('selectedMenu');          
              this.GetAllowedPages();
            },
              (err: HttpErrorResponse) => {
                this.isLoginError = true;
                this.showLodingSpinner = false;
               // swal('','Username or password is not correct!');
               swal('',err.error.error_description);
              });
        } else
          this.formSubmitted = true;
      }
      /*if (form.value.UserName =="" || form.value.UserName == null)
      {
        swal("Warning!","Please enter User Name.");
      }
      else if (form.value.Password =="" || form.value.Password == null)
      {
        swal("Warning!","Please enter Password.");
      }
      else if (this.isServiceNoHavingPhone == true && (form.value.OTP =="" || form.value.OTP == null))
        {
          swal("Warning!","Please enter OTP.");
        } */
      
  }

  GetAllowedPages() {
    this.userService.getAllowedPages()
      .subscribe((data: any) => {
        localStorage.setItem('menuList', JSON.stringify(data));
        this.change.emit(false);
        if (data.length > 0)
          this.router.navigate([data[0].KM_Redirect_URL]);
      },
        (err: HttpErrorResponse) => {
          //alert("Failed!");
        });
  }
  focusOutFunction(form:NgForm)
  {
    //swal("warning!",form.value.UserName, "warning");
    form.controls["OTP"].setValidators;
    //this.form.controls["firstName"].setValidators 
    form.controls["OTP"].updateValueAndValidity();
    document.getElementById('loader-spinner').style.display = "block";
    this.userService.isServiceNoHavingPhone(form.value.UserName).subscribe(
      (response:any) => {        
        this.isServiceNoHavingPhone = response;
        //form.value.IsServiceHavingPhone = response;
        if (this.isServiceNoHavingPhone == true)
        {
          document.getElementById('IsServiceHavingPhone').style.display = "block";
        }
        else
        {
          document.getElementById('IsServiceHavingPhone').style.display = "none";
        }
        //swal("warning!",this.isServiceNoHavingPhone.toString(), "warning");
        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        document.getElementById('loader-spinner').style.display = "none";
      });
  }

  ResendOTP(form:NgForm)
  {
    form.controls["OTP"].clearValidators();
    form.controls["OTP"].updateValueAndValidity();
    form.controls["Password"].clearValidators();
    form.controls["Password"].updateValueAndValidity(); 
    form.value.OTP=null;
    //document.getElementById('OTP').value = "";
    //this.OTP = ' ' ;
    document.getElementById('loader-spinner').style.display = "block";
    this.userService.resendSMS(form.value.UserName).subscribe(
      (response:any) => {        
        this.isSMSResent = response;
        //form.value.IsServiceHavingPhone = response;
        if (this.isSMSResent == true)
        {
          swal("success","OTP is resent","success");
        }
        else
        {
          swal("warning!","OTP is not sent.Try again.","warning");
        }
        //swal("warning!",this.isServiceNoHavingPhone.toString(), "warning");
        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        document.getElementById('loader-spinner').style.display = "none";
        swal('',error.error.Message);
      });    
  }
}




// WEBPACK FOOTER //
// ./src/app/registration/login/login.component.ts